const SIZE = {
    SM: "sm",
    MD: "md",
    LG: "lg",
    XL: "xl",
}

export default SIZE;